import {Component, inject, Input} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {Location, NgClass} from '@angular/common';

import {ComponentType} from '../components.utils';
import {StateService} from '../../state/state.service';

@Component({
  selector: 'pin-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  imports: [RouterLink, NgClass]
})
export class LogoComponent {
  @Input()
  type: string;
  @Input()
  notLoginPage = true;
  @Input()
  customClass: string;
  logoType = ComponentType;
  private stateService = inject(StateService);
  private router = inject(Router);
  private location = inject(Location);

  navigateHome(): void {
    if (this.location.path() === '/accounts') {
      window.location.reload();
    } else {
      this.router.navigate(['/']);
    }
  }

  displaySkipToMainContent(): void {
    if (this.type === this.logoType.AUTHENTICATED) {
      this.stateService.setSkipToMainContentDisplay(true);
    }
  }
}
